import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Get sales reports with filters
export const getSalesReports = createAsyncThunk(
  'reports/getSalesReports',
  async (filters = {}, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const config = {
        headers: {
          Authorization: `Bearer ${auth.userInfo.token}`,
        },
        params: filters
      };

      const { data } = await axios.get('/api/sales/reports', config);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to fetch sales reports'
      );
    }
  }
);

const initialState = {
  reportsData: null,
  loading: false,
  error: null,
  filters: {
    startDate: '',
    endDate: '',
    branch: 'all',
    serviceId: 'all',
    reportType: 'summary'
  }
};

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearReports: (state) => {
      state.reportsData = null;
      state.error = null;
    },
    resetFilters: (state) => {
      state.filters = {
        startDate: '',
        endDate: '',
        branch: 'all',
        serviceId: 'all',
        reportType: 'summary'
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSalesReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSalesReports.fulfilled, (state, action) => {
        state.loading = false;
        state.reportsData = action.payload;
        state.error = null;
      })
      .addCase(getSalesReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.reportsData = null;
      });
  },
});

export const { setFilters, clearReports, resetFilters } = reportsSlice.actions;
export default reportsSlice.reducer;
